// @flow
import type {
  PrimaryKey,
} from 'fc-flow-types/models'

// Libs

export default (state: Object): PrimaryKey => state.mapModule.hoverSamplingPoint
